import React from 'react';
import type { AdditionalVehicleDetailsFormInputs } from '../../schemas/additionalvehicledetails.schema';

interface AutoSaveStatusBannerProps {
    autoSubmit: boolean;
    fieldIssues: Partial<Record<keyof AdditionalVehicleDetailsFormInputs, string>>;
    formIssues: string[];
}

export const AutoSaveStatusBanner: React.FC<AutoSaveStatusBannerProps> = ({ autoSubmit, fieldIssues, formIssues }) => {
    // Issue #859 D3 part 3 — driven from fieldIssues/formIssues, NEVER
    // from `isValid`. `_formValues` updates synchronously in the change
    // handler but `isValid` is only pushed one `await` later, so a render
    // exists where the two disagree; an `isValid`-driven line would flash
    // "auto-save is paused, 0 fields need attention" for one frame.
    const blockingFieldCount = Object.keys(fieldIssues).length;
    const issueCount = blockingFieldCount + formIssues.length;
    const hasBlockingIssues = issueCount > 0;

    return (
        <>
            {autoSubmit && hasBlockingIssues && (
                <p className="text-xs text-mp-error">
                    Auto-save is paused — {issueCount}{' '}
                    {issueCount === 1 ? 'issue needs' : 'issues need'} attention
                    below.
                </p>
            )}
            {autoSubmit && formIssues.length > 0 && (
                <ul className="text-xs text-mp-error list-disc pl-5">
                    {formIssues.map((issue) => (
                        <li key={issue}>{issue}</li>
                    ))}
                </ul>
            )}
        </>
    );
};
